import { render, staticRenderFns } from "./fourthCaseRow.vue?vue&type=template&id=0fa39e42&"
import script from "./fourthCaseRow.vue?vue&type=script&lang=js&"
export * from "./fourthCaseRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports